/* eslint-disable no-underscore-dangle */
import React from 'react';

import dynamic from 'next/dynamic';
import QUERY from '../src/queries/page.graphql';
import GENERIC_QUERY from '../src/queries/pageGeneric.graphql';
import PAGE_QUERY from '../src/queries/pages.graphql';
import BLOG_POSTS_QUERY from '../src/queries/blogPosts.graphql';

import Page from '../src/components/Page';
import Navigation from '../src/components/Navigation';
import NavigationMobile from '../src/components/NavigationMobile';
import Meta from '../src/components/Meta';

import {
  PageQuery,
  PageGenericQuery,
  PageGenericFragment,
  PageFragment,
  BlogPostFragment,
} from '../src/schemas/api';

import api from '../src/utils/api';
import { BlockType } from '../src/enums/blocks';
import { Job } from '../src/utils/jobs';

const Blocks = dynamic(() => import('../src/components/Blocks'), {
  ssr: false,
});

export async function getStaticProps({ params }) {
  const pageQuery: PageQuery = await api(QUERY, { page: params.slug });
  const pageGenericQuery: PageGenericQuery = await api(GENERIC_QUERY);

  let posts: BlogPostFragment[] = [];

  const page: PageFragment | undefined = pageQuery.page?.items[0];
  const blocks = page?.blocks?.items || [];

  const blogPostblock = blocks?.find(
    (d) => d?.__typename === BlockType.BLOCK_BLOG_POST
  );
  if (blogPostblock) {
    // fetch blog posts if there is blog posts block
    const postsQuery = await api(BLOG_POSTS_QUERY, {
      type:
        'type' in blogPostblock &&
        blogPostblock.type.toLowerCase() === 'handbook'
          ? ['Handbook']
          : ['Post', 'Whitepaper'],
    });

    posts = postsQuery.blogPost.items;
  }

  return {
    props: {
      pageGeneric: pageGenericQuery.pageGeneric,
      page,
      posts,
    },
  };
}

export async function getStaticPaths() {
  const result = await api(PAGE_QUERY);
  const paths = result.pages.items
    .filter((p) => p.slug !== '/')
    .map((p) => ({
      params: { slug: p.slug },
    }));

  return {
    paths,
    fallback: false,
  };
}

type CustomPageProps = {
  page: PageFragment;
  pageGeneric: PageGenericFragment;
  posts: BlogPostFragment[];
  jobs?: Job[];
};

function CustomPage({ jobs = [], page, pageGeneric, posts }: CustomPageProps) {
  return (
    <Page generic={pageGeneric}>
      <Meta
        title={page.title}
        description={page.description || undefined}
        image={page.previewImage}
        indexable={page.indexable}
      />
      <Navigation />
      <NavigationMobile />
      <Blocks page={page} jobs={jobs} posts={posts} />
    </Page>
  );
}

export default CustomPage;
